import * as admin from './admin'
import * as prize from './prize'
import * as spin from './spin'
import * as lottery from './lottery'
import * as user from './user'

export default {
  admin,
  prize,
  spin,
  lottery,
  user
}